/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleChatRequestDto } from './SimpleChatRequestDto';
import {
    SimpleChatRequestDtoFromJSON,
    SimpleChatRequestDtoFromJSONTyped,
    SimpleChatRequestDtoToJSON,
    SimpleChatRequestDtoToJSONTyped,
} from './SimpleChatRequestDto';
import type { KnowledgeBaseSelection } from './KnowledgeBaseSelection';
import {
    KnowledgeBaseSelectionFromJSON,
    KnowledgeBaseSelectionFromJSONTyped,
    KnowledgeBaseSelectionToJSON,
    KnowledgeBaseSelectionToJSONTyped,
} from './KnowledgeBaseSelection';

/**
 * 
 * @export
 * @interface KnowledgeChatRequestDto
 */
export interface KnowledgeChatRequestDto {
    /**
     * 
     * @type {SimpleChatRequestDto}
     * @memberof KnowledgeChatRequestDto
     */
    request: SimpleChatRequestDto;
    /**
     * 
     * @type {KnowledgeBaseSelection}
     * @memberof KnowledgeChatRequestDto
     */
    selectedKnowledgeBase?: KnowledgeBaseSelection | null;
    /**
     * 
     * @type {boolean}
     * @memberof KnowledgeChatRequestDto
     */
    isAnonymousMode: boolean;
}

/**
 * Check if a given object implements the KnowledgeChatRequestDto interface.
 */
export function instanceOfKnowledgeChatRequestDto(value: object): value is KnowledgeChatRequestDto {
    if (!('request' in value) || value['request'] === undefined) return false;
    if (!('isAnonymousMode' in value) || value['isAnonymousMode'] === undefined) return false;
    return true;
}

export function KnowledgeChatRequestDtoFromJSON(json: any): KnowledgeChatRequestDto {
    return KnowledgeChatRequestDtoFromJSONTyped(json, false);
}

export function KnowledgeChatRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KnowledgeChatRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'request': SimpleChatRequestDtoFromJSON(json['request']),
        'selectedKnowledgeBase': json['selectedKnowledgeBase'] == null ? undefined : KnowledgeBaseSelectionFromJSON(json['selectedKnowledgeBase']),
        'isAnonymousMode': json['isAnonymousMode'],
    };
}

export function KnowledgeChatRequestDtoToJSON(json: any): KnowledgeChatRequestDto {
    return KnowledgeChatRequestDtoToJSONTyped(json, false);
}

export function KnowledgeChatRequestDtoToJSONTyped(value?: KnowledgeChatRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'request': SimpleChatRequestDtoToJSON(value['request']),
        'selectedKnowledgeBase': KnowledgeBaseSelectionToJSON(value['selectedKnowledgeBase']),
        'isAnonymousMode': value['isAnonymousMode'],
    };
}

